module.exports = __webpack_public_path__ + "media/images/h_logo2-8e7b90db.png";